import { setValidationLocale, setValidationLanguage, FormPath, registerValidationMTEngine, registerValidationRules } from '@formily/core';
import { isNumber } from 'lodash';
setValidationLanguage('zh'); // 如何设置 https://formilyjs.org/#/xbS7SW/vVSBS2HmHn
// 旧的 https:// console.cloud.baidu-int.com/devops/icode/repos/baidu/lsqm-front/console/blob/master:packages/@com/components/src/components/Form/enums/rules.js

setValidationLocale({
  zh: {
    pattern: '格式错误，请按提示规则输入',
    required: '必填项',
    number: '必须是数字',
    enums: '格式错误，请按提示规则输入',
    min: '长度最小为{{min}}',
    max: '长度最大为{{max}}',
    maximum: '最大值为{{maximum}}',
    minimum: '最小值为{{minimum}}',
    len: '长度或条目数必须为{{len}}'
  }
});
registerValidationRules({
  number: v => {
    if (v != null && v !== '' && !isNumber(v)) {
      return '必须是数字';
    }

    return '';
  }
});
registerValidationMTEngine((message, context) => {
  return message.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, $0) => {
    return FormPath.getIn(context, $0);
  });
});
//# sourceMappingURL=es/validator/setValidationLocale.js.map